import store from '../../../store/store';
import { ActionStatus } from '../../../common/constants/action-status';
import { StoreState } from '../../../store/store.interface';
import { areFreeTrialTermsAccepted } from '../../free-trial/store/free-trial.selector';
import { getPromoStatus } from '../../promo-code/promo-code.selectors';
import { hasAtLeastOneFreeTrialProduct } from '../../../common/utils/cart-util';
import {
  getFreightCalculationStatus, 
  getOrderCreationStatus,
  getOrderStatusFailureCount,
  getPaymentDetails,
  getTaxCalculationStatus,
  isShippingAddressValid
} from '../../checkout/shop-checkout';
import { html } from 'lit';
import { MessageType } from '../../alert/global-message.interface';

export const ORDER_STATUS_PENDING_MESSAGE = `Your order is being handled! 
We're reprocessing it automatically, so there's no need to resubmit.`;

export const ORDER_STATUS_FAILURE_MESSAGE = `The order failed to process. 
Please try again later.`;

/**
 * Returns whether the order placement should be disabled.
 */
export function getIsOrderPlacementDisabled() {
  const state = store.getState() as StoreState;
  const isShippable = state.shopCartState.getShopCart.data?.shippable || false;
  const hasOneFreeTrial = hasAtLeastOneFreeTrialProduct(state.shopCartState.getShopCart.data?.products);

  return !getPaymentDetails(state) ||
    (isShippable && !isShippingAddressValid(state)) ||
    getFreightCalculationStatus(state) === ActionStatus.loading ||
    getTaxCalculationStatus(state) === ActionStatus.loading ||
    getPromoStatus(state) === ActionStatus.loading ||
    (hasOneFreeTrial && !areFreeTrialTermsAccepted(state)) || 
    (getOrderStatusFailureCount(state) >= 1 && getOrderStatusFailureCount(state) < 3);
}

/**
 * Returns whether the order is currently being placed.
 */
export function getIsPlacingOrder(): boolean {
  return getOrderCreationStatus(store.getState() as StoreState) === ActionStatus.loading;
}

/**
 * Renders an alert, when order status API is getting failed.
 *
 * @param id the id for the alert
 */
export function orderStatusFailureAlert(id: string) {
  return html`
    <mhecomm-alert
      id="${id}"
      type="${MessageType.danger}"
      message=${ORDER_STATUS_FAILURE_MESSAGE}
      ?dismissible=${true}
    >
    </mhecomm-alert>
  `;
}
